module.exports = _.maxBy;